// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".report-name[data-v-4d8ee684]{text-decoration:underline}.report-name[data-v-4d8ee684],.text-link[data-v-4d8ee684]{cursor:pointer}.paf-download[data-v-4d8ee684]{width:1660px;opacity:0;height:0}.pdf-disabled[data-v-4d8ee684]{color:rgba(0,0,0,.3)}", ""]);
// Exports
module.exports = exports;
